import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import type { DepositContext, DepositResult } from '../../../../../../types/Cashier';
import RejectedCommon from '../RejectedCommon/RejectedCommon';

import { TXTWCL_You_must_wait_for_your_last_de_ELL } from './AnotherInProgress.messages.json';

type Props = DepositResult & DepositContext;

const AnotherInProgress: React.FC<Props> = () => (
  <RejectedCommon>
    <Translation {...TXTWCL_You_must_wait_for_your_last_de_ELL} />
  </RejectedCommon>
);

export default AnotherInProgress;
